// @ts-check
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend/cjs';
import path from 'path';

import CustomFsBackend from './shared/utils/custom-fs-backend.mjs';

const defaultLocale = 'de';
const isServer = typeof window === 'undefined';

/**
 * @type {import('i18next-http-backend').HttpBackendOptions}
 */
const seoHttpBackendOptions = {
  loadPath: ([lng], [ns]) =>
    new URL(`/seo-landing-pages/?ns=${ns}&lng=${lng}`, process.env.NEXT_PUBLIC_BACKEND_ENDPOINT || 'http://localhost:4001').toString(),
};

/**
 * @type {import('next-i18next/pages').UserConfig}
 */
const config = {
  backend: isServer
    ? {
        backends: [CustomFsBackend, HttpBackend],
        backendOptions: [{ localePath: path.resolve('./public/locales') }, seoHttpBackendOptions],
      }
    : { loadPath: '/locales/{{lng}}/{{ns}}.json' },
  fallbackLng: { 'de-AT': ['de'], default: [defaultLocale] },
  i18n: {
    defaultLocale,
    locales: [defaultLocale],
  },
  partialBundledLanguages: true,
  reloadOnPrerender: process.env.NEXT_PUBLIC_ENV === 'development',
  serializeConfig: false,
  use: isServer ? [ChainedBackend] : [HttpBackend],
};

export default config;
